module.exports = __webpack_public_path__ + "static/img/zhongzhongka8.b42513b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhongzhongka8.png
// module id = GJ4p
// module chunks = 16